// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1384":"101e831f","2990":"155ccdc5","3067":"b0ce431a","7548":"8b7f164a","8245":"b0ce431a"}[chunkId] + ".chunk.css";
};